// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2fIbe","disabled":"FileBtn_disabled__3BavZ","warn":"FileBtn_warn__2uzDb","fade":"FileBtn_fade__2m6He"};